module.exports = __webpack_public_path__ + "img/南阳市-c.da0a2ca1.png";